<template>
  <div id="app">
    <div class="top-header">
      <div class="n-header">
        <div class="content">
          <!-- logo -->
          <div class="logo" @click="goIndex">
            <img src="../../assets/img/logo.png" alt />
          </div>
          <div v-if="logined" class="logined" @click.stop="popShow">
            <img :src="userData.pic || ''" alt />
          </div>
          <!-- 登录注册 -->
          <ul v-else class="login">
            <li id="register" @click="showReg">
              <span>注册</span>
            </li>
            <li id="login" @click="showLogin">
              <span>登录</span>
            </li>
          </ul>
          <div v-if="outpop && logined" class="user-info">
            <li @click.stop="myData">个人资料</li>
            <li @click.stop="outLogin">退出登录</li>
          </div>
          <!-- <div v-if="outpop && logined && (sta == 3)" class="user-info personal-info">
            <li @click.stop="outLogin">退出登录</li>
          </div>-->
          <!-- 其他端 -->
          <ul class="other">
            <li class="applet" @click.stop="codeShow">小程序</li>
            <div v-if="code" class="erweima">
              <img src="../../assets/img/xiaoCode.jpg" alt />
            </div>
            <li class="applet" @click.stop="appcodeShow">APP</li>
            <div v-if="code_a" class="erweima app-code">
              <img src="../../assets/img/code.png" alt />
            </div>
            <li v-if="sta != 3" @click="attestation">
              <i class="iconfont icon-Shape"></i>档案号
            </li>
          </ul>
		<!--  <ul class="other">
			  <li @click.stop="codeShowSx">
				<i class="iconfont icon-Shape"></i>
			  </li>
			  <div v-if="code_b" class="erweima" style="left:0px;height: 60px;">
				<div @click="look_tongzhi()" style="line-height: 25px;cursor: pointer;">通知</div>
				<div @click="look_guanzhu()" style="line-height: 25px;cursor: pointer;">关注</div>
			  </div>
		  </ul> -->
        </div>
      </div>
    </div>
    <component v-show="panelModal" :is="name" @childUserInfo="fromChild"></component>
  </div>
</template>
<script>
import $ from "jquery";
import login from "../login/login";
import register from "../login/register";
import authentic from "../login/authentic";
import person from "../media/person";
import mediaOrg from "../media/mediaOrg";
import checkPass from "../media/checkPass";
import changePassword from "../login/changePassword";
import bindPhone from "../login/bindPhoneLogin";
import { log } from "util";
export default {
  data() {
    return {
      panelModal: false,
      code: false,
      code_a: false,
	  code_b:false,
      name: "",
      outpop: false,
      noLogin: true,
      phone: "",
      userData: {},
      sta: ""
    };
  },
  components: {
    login,
    register,
    authentic,
    person,
    mediaOrg,
    checkPass,
    bindPhone
  },
  computed: {
    logined() {
      if (this.$store.state.userInfo.token && this.$store.state.userInfo.id) {
        return true;
      } else {
        return false;
      }
    },
    token() {
      return this.$store.state.userInfo.token;
    },
    // sta() {
    //   return this.$store.state.userInfo.status;
    // },
    role() {
      return this.$store.state.userInfo.role;
    }
  },
  mounted() {
	  // console.log(777)
	  // console.log(this.$route.query.token)
	  var that = this
	  if(this.$route.query.token){
		  var token = this.$route.query.token
		   localStorage.setItem('token', token);
			this.$http
			  .get("/api/user/007-getCusUserInfo", {
				params: {
				  token: token,
				}
			  })
			  .then(res => {
				console.log(res, "获取用户信息并保存");
				if ( res.data.code == 0) {
				  var data = res.data.rows[0];
				  that.getStatuss(data.id,data.phone,data.token,data.role)
				}else{
					this.$store.commit("userPerson", { a: true });
					this.outpop = false;
					this.noLogin = true;
					this.$store.commit("setUserInfo", {
					  id: "",
					  token: "",
					  phone: "",
					  role: "",
					  status: "",
					  remark: ""
					});
					this.$parent.k = 0;
				}
			  })
	  }
    // 小程序，APP
    $(".other li,.login li").click(function() {
      $(this)
        .addClass("active")
        .siblings()
        .removeClass("active");
      $(this)
        .parent()
        .siblings()
        .children("li")
        .removeClass("active");
    });
    if (this.token) {
      this.getData();
    }
    this.getStatus();
	console.log(this.$store.state.userInfo)
	if(this.$store.state.userInfo.phone==''){
		this.bindPhoneShow()
	}
  },
  methods: {
	  goIndex(){
		   window.location.href = "https://www.jzda001.com"
	  },
	 getStatuss(id,phone,token,role){
	   // console.log(this.$store.state.userInfo.status)
	   console.log(id+'---------155')
	   console.log(token+'---------156')
	   this.$http
		 .get("/api/media/007--accountSetting", {
		   params: {
			 token: token,
		   }
		 })
		 .then(res => {
		   console.log(res, "获取认证状态");
		   if ( res.data.code == 0) {
			 var checkStatus,checkRemark;
			 if(res.data.rows== ''){
			   checkStatus = null ;
			   checkRemark = null ;
			 }else{
			   checkStatus = res.data.rows[0].status;
			   checkRemark = res.data.rows[0].remark
			 }
			 var userInfo = {
			   id: id,
			   phone: phone,
			   token: token,
			   role: role,
			   status: checkStatus,
			   remark: checkRemark
			 };
			 this.$store.commit("setUserInfo", userInfo);
			 this.$emit("childUserInfo", {
			   id: userInfo.id,
			   phone: userInfo.phone,
			   token: userInfo.token,
			   role:  userInfo.role,
			   status: userInfo.status,
			   remark: userInfo.remark
	 
			 });
			  if ( res.data.rows[0].status == 3) {
			   this.$store.commit("userPerson", { a: false });
			   this.$parent.$parent.ki = 0;
			 } else {
			   this.$store.commit("userPerson", { a: true });
			   this.$parent.$parent.k = 0;
			 }
			 // this.$router.go(0);
			 // window.location.href = this.setPar am('token')
			 var url = document.URL,   //获取当前页面的网址信息
			      URL;
			  var num = url.indexOf('?');  //获取＃在的位置信息
			     if (num){
			            URL = url.substring(0,num);  //截取网址信息
			            history.pushState(null,null,URL);  //将网址设置
			       }
		   }
		 })
		 .catch(err => {
		   console.log(err);
		 });
	 },
	look_tongzhi(){
		this.$router.push({ path: "tongZhi"});
	},
	look_guanzhu(){
		this.$router.push({ path: "myCare"});
	}, 
    getStatus() {
      console.log(this.token)
      this.$http
        .get("/api/media/007--accountSetting", {
          params: {
            token: this.token
          }
        })
        .then(res => {
          console.log(res, "获取认证状态");
          if (res.data.code == 0) {
            if (res.data.rows.length == 0) {
              this.sta == "";
            } else {
              this.sta = res.data.rows[0].status;
            }
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    attestation() {
	console.log(this.token)
      this.$http
        .get("/api/media/007--accountSetting", {
          params: {
            token: this.token
          }
        })
        .then(res => {
          console.log(res, "获取认证状态");
          if (res.data.code == 0) {
            if (res.data.rows.length == 0) {
              this.sta == "";
            } else {
              this.sta = res.data.rows[0].status;
            }
            console.log(this.role);
            console.log(this.sta);
            if (this.token && this.sta == "") {
              document.documentElement.scrollTop = 0;
              this.panelModal = true;
              this.name = "authentic";
            } else if (this.token && this.sta != 3 && this.sta != "") {
              this.panelModal = true;
              this.name = "checkPass";
              document.documentElement.scrollTop = 0;
            } else if (this.token && this.sta == 3) {
              this.$message("您已认证过,请勿重新认证");
            }
          } else {
            this.$message("请登录");
            this.panelModal = true;
            this.name = "login";
            document.documentElement.scrollTop = 0;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    myData() {
      this.outpop = false;
      this.$router.push("/perData");
    },
    showLogin() {
      //登录弹框显示隐藏
      this.name = "login";
      this.panelModal = true;
      this.outpop = false;
      document.documentElement.scrollTop = 0;
    },
    showReg() {
      //注册弹框显示隐藏
      this.name = "register";
      this.panelModal = true;
      this.outpop = false;
      document.documentElement.scrollTop = 0;
    },
	bindPhoneShow(){
		this.name = "bindPhone";
		this.panelModal = true;
		this.outpop = false;
		document.documentElement.scrollTop = 0;
	},
    codeShow() {
      //小程序二维码显示隐藏
      this.code = !this.code;
      const fn = () => {
        this.code = !this.code;
        document.removeEventListener("click", fn);
      };
      document.addEventListener("click", fn, false);
    },
	codeShowSx(){
		this.code_b = !this.code_b;
		const fn = () => {
		  this.code_b = !this.code_b;
		  document.removeEventListener("click", fn);
		};
		document.addEventListener("click", fn, false);
	},
    appcodeShow() {
		var u = navigator.userAgent;
		var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
		var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
		if(isiOS && isIos== 'IOS') {
			window.location.href = 'https://apps.apple.com/cn/app/heart-language-icle/id1476235011';
		}else{
			window.location.href = 'https://appgallery1.huawei.com/#/app/C101555263';
		}
		return false
      this.code_a = !this.code_a;
      const fn = () => {
        this.code_a = !this.code_a;
        document.removeEventListener("click", fn);
      };
      document.addEventListener("click", fn, false);
    },
    popShow() {
      //退出框显示隐藏
      this.outpop = !this.outpop;
      const fn = () => {
        this.outpop = !this.outpop;
        document.removeEventListener("click", fn);
      };
      document.addEventListener("click", fn, false);
    },
    fromChild(data) {
      this.panelModal = false;
      if (data.type == "mediaOrg") {
        this.panelModal = true;
        this.name = "checkPass";
      }
      this.noLogin = false;
      this.phone = data.phone;
      if (this.token) {
        this.getData();
      }
    },
    outLogin() {
      this.$http
        .get("/api/user/009-logout", {
          params: {
            token: this.token
          }
        })
        .then(res => {
          // console.log(res, "退出成功");
          if (res.status == 200 && res.data.code == 0) {
            this.$message("退出登录");
            this.$store.commit("userPerson", { a: true });
            this.outpop = false;
            this.noLogin = true;
            this.$store.commit("setUserInfo", {
              id: "",
              token: "",
              phone: "",
              role: "",
              status: "",
              remark: ""
            });
            this.$parent.k = 0;
            this.$router.push({ path: "/iPage" });
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getData() {
      //获取用户信息
      this.$http
        .get("/api/user/013-getUserInfoById", {
          params: {
            id: this.$store.state.userInfo.id
          }
        })
        .then(res => {
          // console.log(res, "获取用户信息");
          if (res.status == 200 && res.data.code == 0) {
            this.userData = res.data.rows[0];
          }
        })
        .catch(err => {
          console.log(err);
        });
    }
  }
};
</script>
<style scoped>
.user-info.personal-info {
  width: 120px;
  height: 50px;
}
.user-info.personal-info li:first-child {
  border: none;
}
@media (min-width: 320px) and (max-width: 500px) {
  /* 头部隐藏 */
  .top-header {
    /* display: none; */
  }
}
</style>